module.exports = __webpack_public_path__ + "img/palladium.939a909.webp";